import {
  Autocomplete,
  Button,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import ProcessListFiltersItems from "./ProcessListFiltersItems";
import CreateProcess from "../Modal/CreateProcess";
// import EditProcess from "../Modal/EditProcess";
import "./ProcessListFilters.css";
import { useSelector } from "react-redux";
import { setSelectedETLProcessList } from "../../../../../features/etlProcessListSlice";
import store from "../../../../../store";
import { useSearchParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

interface Props {
  setSelectedProcess: any;
  selectedProcess: any;
  setStatus: any;
  status: any;
  oauthTokenHeader: any;
  setReload: any;
  selectedRow: any;
  setSelectedRow: any;
  page: number;
  setPage: any;
  searchStatus: any;
  setSearchStatus: any;
  processes: any;
}

const ProcessListCard = ({ oauthTokenHeader, setReload, processes }: Props) => {
  const { selectedETLProcessList } = useSelector(
    (state: any) => state?.ETLProcessList
  );

  const [openModal, setOpenModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  // const process = ETLProcessListData.map((process: any) => process?.name);
  const processeNames = processes?.ETL_PROCESS_NAME?.map((process: any) => process?.label);

  const handleClose = () => {
    setOpenModal(false);
  };
  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    store.dispatch(setSelectedETLProcessList(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Paper className="chainsFiltersWrap">
        <div style={{ padding: "16px" }}>
          {/* Heading */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Grid item xs={8}>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                ETL Process List
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                Create new or edit existing ETL Processes.
              </Typography>
            </Grid>
          </Grid>

          {/* Filter part */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginTop: "5px",
              }}
            >
              {/*Queue Name */}
              <Autocomplete
                data-tracker="220"
                options={processeNames ? processeNames : []}
                value={selectedETLProcessList}
                onChange={(_: unknown, newValue: any) => {
                  store.dispatch(setSelectedETLProcessList(newValue));

                  // Preserve existing search params while updating 'selectedTemplate'
                  setSearchParams((prevParams) => {
                    const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                    if (newValue) {
                      updatedParams.search = newValue; // Set new value
                    } else {
                      delete updatedParams.search; // Remove from URL if cleared
                    }
                    return updatedParams;
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Process Name"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ marginLeft: "12px" }} />
                        </InputAdornment>
                      ),
                    }}
                    color="secondary"
                  />
                )}
                size="small"
                sx={{ width: "300px" }}
              />
              <ProcessListFiltersItems />
            </div>

            {/* Action Buttons */}
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Button
                data-tracker="369"
                variant="contained"
                color="secondary"
                onClick={() => setOpenModal(true)}
                endIcon={<AddIcon />}
              >
                Create New Process
              </Button>
              <CreateProcess
                openModal={openModal}
                onCloseModal={handleClose}
                oauthTokenHeader={oauthTokenHeader}
                setReload={setReload}
              />
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};
export default ProcessListCard;
